import DialogComponent from "../../../components/DialogComponent";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { deleteItem, getItem, updateItem } from "src/modules/spItems/actions";
import Trash from "src/components/ui-icons/buttons/Trash";
import Button from "src/components/Button";
import { selectItem } from "src/modules/spItems/selectors";
import { selectCurrentUser } from "src/modules/users/selector";
import { addItemRequest, deleteItemRequest, getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import { emailQueueListName } from "src/api/config/email.config";
import { approversCardDocumentListName, historyByDocumentListName, historyChangeFieldsDocumentListName, myDocumentsListName } from "src/api/config";
import { docApprovers, docStatuses } from "src/api/config/systemSwitch";
import { useEffect, useState } from "react";

type Props = {
    open: boolean;
    toggleDialog: any;
    setOpen: any;
    setCloseAllModals: any;
    closeAllModals: any;
    setCustomLoading: any;
    card: any;
    setCard: any;
}

const ArchiveConfirmModal = (props: Props) => {

    const { open, toggleDialog, setOpen, setCloseAllModals, closeAllModals, setCustomLoading, card, setCard } = props;
    const currentUser = useAppSelector(selectCurrentUser);

    const addArchiveCard = (params: any) => {
        setCustomLoading(true);
        let dataHistoryCard: any = [], historyFields: any = {}
        dataHistoryCard = [
            ...dataHistoryCard,
            {
                Title: `History card # ${card.ID}`,
                Approvers: [currentUser.email],
                DocumentID: card.ID,
                ChangeDate: new Date(),
                ApprovalGroup: docApprovers.Creater, // Список Approvers - Создатель
                Statuses: [docStatuses.sendArchive]
            },
        ];
        historyFields = {
            Title: `History fields card # ${card.ID}`,
            DocumentID: card.ID,
            ChangeDate: new Date(),
            Statuses: [docStatuses.sendArchive],
        };
        let emailQueue: any = [];
        let approversRequests: any = [];
        emailQueue = [
            ...emailQueue,
            getItemsRequest({ listName: emailQueueListName, filters: { CheckDoc: String(card.ID) } })
        ];
        approversRequests = [
            ...approversRequests,
            getItemsRequest({
                listName: approversCardDocumentListName,
                filters: { Document: card.ID, VersionDocument: false },
            }),
        ];
        let removeData: any = [];
        Promise.all(emailQueue).then((values: any) => {
            if (values.length > 0) {
                values.forEach((value: any) => {
                    if (value.items.length > 0) {
                        value.items.forEach((email: any) => {
                            removeData = [
                                ...removeData,
                                deleteItemRequest({ listName: emailQueueListName, ID: email.ID }),
                            ];
                        });
                    }
                });
            }
            Promise.all(approversRequests).then((values: any) => {
                if (values.length > 0) {
                    values.forEach((value: any) => {
                        if (value.items.length > 0) {
                            value.items.forEach((approver: any) => {
                                removeData = [
                                    ...removeData,
                                    deleteItemRequest({ listName: approversCardDocumentListName, ID: approver.ID }),
                                ];
                            });
                        }
                    });
                }
                Promise.all(removeData).then((results: any) => {
                    let dataArr: any = [
                        addItemRequest({ listName: historyChangeFieldsDocumentListName, body: historyFields, updateReducer: false }),
                        addItemRequest({ listName: historyByDocumentListName, bodyArr: dataHistoryCard, body: dataHistoryCard[0], updateReducer: false }),
                        updateItemRequest({ listName: myDocumentsListName, body: { ID: card.ID, Status: docStatuses.archive } })
                    ]
                    Promise.all(dataArr).then(results => {
                        getItemsRequest({ listName: myDocumentsListName, filters: { ID: card.ID } }).then((result) => {
                            setCard(result.items.length > 0 && result.items[0] || null);
                            setCustomLoading(false);
                        });
                    });
                });
            });
        });
    }
    return (
        <DialogComponent open={open} toggleDialog={toggleDialog}>
            <div className="removeElement">
                <span className="block text-[24px] mb-[18px] leading-7.5 font-semibold">Архивация документа</span>
                <span className="block text-[16px] leading-[22px] mb-[38px]">Вы уверены, что хотите архивировать документ?<br />В данном случае документ «{card.Title}» будет<br />недоступен к просмотру.</span>
                <div className="divide-y mb-[40px] h-px border-t" />
                <div className="flex justify-between">
                    <div className="mr-5">
                        <Button
                            classBg="btn-white"
                            shadow={true}
                            text="Отмена"
                            customFunction={setCloseAllModals}
                            paramsCustomFunction={closeAllModals}
                            open={open}
                            setOpen={setOpen}
                        />
                    </div>
                    <div className="ml-5">
                        <Button
                            open={open}
                            setOpen={setOpen}
                            classBg="btn-dark"
                            text="Архивировать"
                            customFunction={addArchiveCard}
                            paramsCustomFunction={card.ID}
                        />
                    </div>
                </div>
            </div>
        </DialogComponent>
    );
};

export default ArchiveConfirmModal;
